// USED TO SET THE ACTIVE VARIATION FROM THE ABLYFT.
window.addNotificationsAttribute = function (attributes) {
	if (window.abTesting?.orderAttributesEnabled) {
		fetch(`${Shopify.routes.root}cart/update.js`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ attributes }),
			keepalive: true,
		})
			.then((response) => {
				if (!response.ok) {
					console.error('Failed to update cart attributes:', response);
				}
			})
			.catch((error) => {
				console.error('Failed to update cart attributes:', error);
			});
	}
};
